import * as React from "react";
import { CardWithDate } from "../../../../../../store/calendar/selectors";
import Drawer from "@material-ui/core/Drawer";
import Card from "../../../../../Feed/Card/Card";
import "./CardPopup.css";
import { getReadableCardType, getDatePeriod } from "../../../../../../utils";
import Schedule from "@material-ui/icons/Schedule";
import Button from "../../../../../Button/Button";
import { CardType } from "../../../../../../types/LibraryCard";

interface Props {
	card: CardWithDate;
	open: boolean;
	onClose: () => void;
}

const CardPopup: React.FC<Props> = (props) => {
	const onClick = () => {
		//window.location.href = `/books/#/${props.card.card.eId}/`;

		window.location.href = `/book/${props.card.card.book.woo_id}`;
	};

	return (
		<Drawer
			anchor="bottom"
			open={props.open}
			onClose={props.onClose}
			classes={{
				paper: "calendar-book-popup__paper",
			}}
		>
			<Card
				book={{
					...props.card.card.book,
					card: {
						id: props.card.card.eId,
						type: props.card.card.cardType,
					},
				}}
				toBookPage={true}
			/>

			<div className="calendar-book-popup__peroid">
				<Schedule />
				{getReadableCardType(props.card.type)}{" "}
				{getDatePeriod(
					props.card.startDate,
					props.card.endDate,
					"с ",
					" по ",
					props.card.type === CardType.WantRead
				)}
			</div>

			<Button
				className="calendar-book-popup__button"
				type="primary"
				onClick={onClick}
			>
				Открыть карточку
			</Button>
		</Drawer>
	);
};

export default CardPopup;
